import { render } from "./UserOptions.vue?vue&type=template&id=47c182e8&ts=true"
import script from "./UserOptions.vue?vue&type=script&lang=ts"
export * from "./UserOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__